const getAvailableOptions = shopifyProduct =>
  shopifyProduct.variants.edges
    .filter(({ node: { quantityAvailable } }) => quantityAvailable > 0)
    .map(({ node: { selectedOptions: options } }) =>
      options.reduce((acc, { name, value }) => ({ ...acc, [name]: value }), {})
    );

export default getAvailableOptions;
